import * as Sentry from '@sentry/react';
import 'normalize.css';
import 'uno.css';
import './common.css';

import './overlayscrollbar.css';

import { runToolkit } from '@/libs/mpa';

// import MediecoAntdTheme from '@/wrappers/MediecoAntdTheme';

Sentry.init({
  dsn: 'https://954d32c990ca71813bc7a7aec1f54071@sentryio.ns-svc.cn/41',
});

runToolkit({
  reactComponents: {},
  asyncReactComponents: {
    EinPaper: () => import('@/EinPaper'),
    LoginPage: () => import('@/components/LoginPage'),
    JoinSpacePage: () => import('@/components/JoinSpacePage'),
    // ZyyUserInfoPage: () => import('@/custom/zyy/UserInfoPage'),
  },
  //reactAppWrappers: [MediecoAntdTheme],
});
